// =============================================================================
// SaasAdminRoute — gate for the platform admin console (/admin/*). Simple
// isAdmin (account_type='admin') check via redux — NOT the legacy feature-map
// RBAC (/admin/feature/by-user), which the SaaS-only backend does not serve.
// If not an admin, it shows the admin login inline (self-contained).
// =============================================================================
import React from "react";
import { useSelector } from "react-redux";
import { selectIsAdmin } from "./auth.selector";
import SaasAdminLogin from "../../pages/saas-admin/SaasAdminLogin";

const SaasAdminRoute = ({ children }) => {
  const isAdmin = useSelector(selectIsAdmin);
  if (!isAdmin) return <SaasAdminLogin />;
  return children;
};

export default SaasAdminRoute;
